import EventEmitter from 'eventemitter3';

import config from '../../../client-config';

export const getPlayerUrl = (eventId) => {
  let playerBaseUrl = process.env.WEBPLAYER_BASE_URL || config.publicBaseUrl;

  try {
    const playerUrlOverride = window.localStorage.getItem('bambuserPlayerBaseURLOverride');
    if (playerUrlOverride?.match(/^https?:\/\//)) {
      playerBaseUrl = playerUrlOverride;
    }
  } catch (err) {
    isDebug && console.log('Could not read the saved configuration', err);
  }

  if (!playerBaseUrl.endsWith('/')) playerBaseUrl += '/';

  if (playerBaseUrl.startsWith('//')) {
    playerBaseUrl = window.location.protocol + playerBaseUrl;
  }

  const params = new URLSearchParams({
    eventId,
    deferReactAppInit: true,
    withBaaSPlayerPreloading: true,
    autoplay: true,
    withStatePreloading: true,
  });

  return `${playerBaseUrl}?${params.toString()}`;
};

const checkIfDebug = () => {
  const isDev = process.env.NODE_ENV === 'development';
  const urlParams = new URLSearchParams(window.location.search);
  return isDev || urlParams.get('debugBambuser');
};

const isDebug = checkIfDebug();

const PREFIX = 'baas-player:';

export class LightWeightPlayerAdapter extends EventEmitter {
  constructor({ eventId, node }) {
    super();
    this._eventId = eventId;
    this._iframe = this._createIframe();
    this._setupPlayerMessageListeners();
    this.currentTime = 0;

    node.appendChild(this._iframe);
  }

  _createIframe() {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', getPlayerUrl(this._eventId));
    iframe.setAttribute('frameborder', 0);
    iframe.setAttribute('allowTransparency', true);
    iframe.setAttribute('allow', 'fullscreen; autoplay;');
    iframe.setAttribute('title', 'Live video shopping');

    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '100%');

    return iframe;
  }

  _onMessage(event) {
    const iframe = this._iframe;
    if (iframe.contentWindow !== event.source) return;

    try {
      const { eventName, data } = event.data || {};

      if (!eventName?.startsWith(PREFIX)) {
        isDebug && console.log('Event name is not supported', eventName);
        return;
      }

      isDebug && console.log('Event received from player', eventName, data);

      const eventNameWithoutPrefix = eventName.replace(PREFIX, '');

      // When the timeupdate event is received, we update the currentTime property
      // This is match bass-player's API
      if (eventNameWithoutPrefix === 'timeupdate') {
        this.currentTime = data?.currentTime;
      }

      this.emit(eventNameWithoutPrefix, data);
    } catch (e) {
      isDebug && console.log('Error parsing message from player', e);
    }
  }

  _setupPlayerMessageListeners() {
    this._boundOnMessageListener = this._onMessage.bind(this);

    window.addEventListener('message', this._boundOnMessageListener);
  }

  set scaleMode(mode) {
    this._iframe.contentWindow.postMessage({ eventName: 'widgets:setScaleMode', data: mode }, '*');
  }

  pause() {
    this._iframe.contentWindow.postMessage({ eventName: 'widgets:pause' }, '*');
  }

  addEventListener(...args) {
    super.addListener(...args);
  }

  destroy() {
    if (this._boundOnMessageListener) {
      window.removeEventListener('message', this._boundOnMessageListener);
      this._boundOnMessageListener = null;
    }

    super.removeAllListeners();
    this._eventId = null;
    this._iframe.remove();
    this._iframe = null;
  }
}
